import React, { Component } from 'react';
import Navbar from './mycomponents/navbar';
import StudentDashBody from './mycomponents/studentdashbody';
import PalmeeupIcon from './mycomponents/palmeeupbuttonicon';

class StudentDash extends Component {
    state = {  } 
    render() { 
        return (
            <React.Fragment>
                <Navbar/>
               
                <StudentDashBody user = {this.props.user}/>
                <PalmeeupIcon/>
                </React.Fragment>
        );
    }
}
 
export default StudentDash;